import { EditIcon, Button, Box } from '@occc-app/design-system';

import { StatisticsItem } from './StatisticsItem';

type PointDetailsProps = {
  points: number;
  toggleUpdatePointsModal: () => void;
  isPointsAdjustmentEnabled: boolean;
  isEditable: boolean;
};

const PointDetails = (props: PointDetailsProps) => {
  const { points, toggleUpdatePointsModal, isPointsAdjustmentEnabled, isEditable } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box position='relative' textAlign='center'>
        <StatisticsItem value={points} label='Points Balance' />
        {isEditable && (
          <Box
            sx={{
              position: 'absolute',
              right: '-15px',
              top: '50%',
              transform: 'translate(100%, -50%)',
            }}
          >
            <Button
              variant='contained'
              size='small'
              onClick={toggleUpdatePointsModal}
              disabled={!isPointsAdjustmentEnabled}
              sx={(theme) => ({
                padding: theme.spacing(0.5),
                display: 'flex',
                height: 32,
                width: 32,
                minWidth: 32,
              })}
            >
              <EditIcon fontSize='small' />
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PointDetails;
